import styled from "styled-components"


export const H1 = styled.h1 `
  color: white;
  text-align: center;
  font-weight: 900;
`
export const Div = styled.div `
  height: 100vh;
  width: 100%;
  margin-top: 7em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
`
export const P = styled.p `
  color: white;
  width: 50vw;
  text-align: center;
  margin: auto;
`

export const Socials = styled.div `
  width: 10em;
  height: 3em;  
  position: absolute;
  bottom: 0;
  background: white;
`
